import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';

const Loader = ({ open = true, overlay = false }) => {
	if (!open) {
		return null;
	}

	const progressBar = (
		<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				zIndex: 2001,
				width: '100%',
			}}
		>
			<LinearProgress color="primary" />
		</Box>
	);

	if (!overlay) {
		return progressBar;
	}

	return (
		<>
			<Backdrop
				open
				sx={{
					zIndex: 2000,
					color: 'primary.main',
					backgroundColor: 'rgba(255, 255, 255, 0.6)',
				}}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			{progressBar}
		</>
	);
};

Loader.propTypes = {
	open: PropTypes.bool,
	overlay: PropTypes.bool,
};

export default Loader;
